import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AccessControlService } from '../../../../network/services/access-control.service';
import { DialogUtil } from '../../../../utils/dialog-utils';
import { KeywordsAndConstants } from '../../../../core/keywords-and-constants';
import {
  BehaviorSubject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  from,
  map,
  mergeMap,
  Observable,
  of,
  Subject,
  switchMap,
  tap,
} from 'rxjs';
import { MessageType } from '../../../../enums/message-type';
import { ErrorAction } from '../../../../enums/error-action';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionService } from '../../../../network/services/transaction.service';
import { CustomDecimalFormatPipe } from '../custom-decimal-format.pipe';
import { ExchangeRateScalePipe } from '../exchange-rate-scale.pipe';
import { CountryService } from '../../../../network/services/country.service';
import { ShowFieldSchemaValueComponent } from '../../dynamic-page/display-field-schema-value/show-field-schema-value/show-field-schema-value.component';
import { environment } from '../../../../environments/environment';
import { driver } from 'driver.js';
import { StringVariable } from '../../../../core/string-variable';
const API_Limit = environment.dataLimit;

@Component({
  selector: 'app-transaction-estimate',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    CustomDecimalFormatPipe,
    ExchangeRateScalePipe,
    ShowFieldSchemaValueComponent,
  ],
  templateUrl: './transaction-estimate.component.html',
  styleUrl: './transaction-estimate.component.scss',
})
export class TransactionEstimateComponent implements OnInit, OnDestroy {
  estimateForm!: UntypedFormGroup;
  submitted: any = false;
  error: any = '';
  @ViewChild('rowContainer') rowContainer!: ElementRef;
  isWideScreen = true;
  @Input() forTransactionPage: boolean = false;

  countryIngressList: Array<any> = [];
  countryEgressList: Array<any> = [];
  currencyIngressList: Array<any> = [];
  currencyEgressList: Array<any> = [];

  customerList: Array<any> = [];
  customer$!: Observable<any>;
  currentCustomerSubject: BehaviorSubject<any>;
  customerSearch$ = new Subject<string>();
  offsetTokenValueForCustomer = '';
  searchTermForCustomer: any;
  dataLengthForCustomer: any;

  receiverList: Array<any> = [];
  receiver$!: Observable<any>;
  currentReceiverSubject: BehaviorSubject<any>;
  receiverSearch$ = new Subject<string>();
  offsetTokenValueForReceiver = '';
  searchTermForReceiver: any;
  dataLengthForReceiver: any;
  uniqueIdsForReceiver: Array<any> = [];

  modeOfPaymentList: Array<any> = [];
  modeOfPayoutList: Array<any> = [];

  loginType: any;
  estimateDetails: any;
  userParams: any = {};
  showField: any;
  estimateData: any;
  purposeList: Array<any> = [];

  modalRef?: BsModalRef;
  config: any = {
    class: 'modal-md modal-dialog-centered',
  };
  isLoading = false;
  showCreateTransaction: boolean = true;

  baseUrl: string = '';
  customerId: string | null = null;
  messageEmitEventListener: any;
  paymentDetailsData: Array<any> = [];
  showWarningMessage: boolean = false;

  lockedChargeStrategy: boolean = false;
  lastEditedAmout: boolean = true;

  isToggleDisabled = false;

  documentUpload: any;
  documentUploadShow = 'getDocuments GET';
  checkButtonAccessCallbackForDocumentUpload = (
    isAccessable: boolean
  ): void => {
    this.documentUpload = isAccessable;
  };

  driverObj: any;
  showTourGuide: boolean = false;
  tourStarted: boolean = false;

  selectedCountry:any;
  
  constructor(
    private constants: KeywordsAndConstants,
    private dialog: DialogUtil,
    public _controlService: AccessControlService,
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _transactionService: TransactionService,
    private cdr: ChangeDetectorRef,
    private modalService: BsModalService,
    private router: Router,
    private route: ActivatedRoute,
    private _countryService: CountryService,
    public variable: StringVariable,
  ) {
    this._controlService.checkCategoryByButton(
      this.documentUploadShow,
      this.checkButtonAccessCallbackForDocumentUpload
    );
    this.currentCustomerSubject = new BehaviorSubject<any>(undefined);
    this.customerSearch$
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((val: any) => {
        if (val?.length > 2) {
          if (
            this.searchTermForCustomer == undefined ||
            this.searchTermForCustomer != val
          ) {
            this.offsetTokenValueForCustomer = '';
            this.customerList = [];
          }
          this.searchTermForCustomer = val;
          this.customer$ = this.currentCustomerSubject.asObservable();
          this.customerListForSelect(
            this.offsetTokenValueForCustomer,
            this.searchTermForCustomer
          ).subscribe();
        } else {
          this.offsetTokenValueForCustomer = '';
          this.customerList = [];
          this.currentCustomerSubject.next(this.customerList);
        }
        const scrollContainer = document.querySelector(
          '.ng-dropdown-panel-items'
        );
        if (scrollContainer) {
          scrollContainer.scrollTop = 0;
        }
      });
    this.currentReceiverSubject = new BehaviorSubject<any>(undefined);
    this.receiverSearch$
    .pipe(debounceTime(400), distinctUntilChanged())
    .subscribe((val: any) => {
      if (
        this.searchTermForReceiver == undefined ||
        this.searchTermForReceiver != val
      ) {
        this.offsetTokenValueForReceiver = '';
        this.receiverList = [];
      }
      this.searchTermForReceiver = val;
      let formsObj = {};
      if (this.estimateForm.controls['customerUserId']?.value) {
        formsObj = {
          customerId: this.estimateForm.controls['customerUserId']?.value,
          showOnlyReceiversUnderYou: false,
        };
        this.receiver$ = this.currentReceiverSubject.asObservable();
        this.receiverListForSelect(
          formsObj,
          this.offsetTokenValueForReceiver,
          this.searchTermForReceiver
        ).subscribe();
      }
      const scrollContainer = document.querySelector(
        '.ng-dropdown-panel-items'
      );
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
    });
    this.baseUrl = window.location.origin;
    this.route.fragment.subscribe(fragment => {
      this.selectedCountry = fragment;
    });
  }

  startTour(): void {
    this.showTourGuide = false;
    let steps: any = [
      {
        element: '#amount',
        popover: {
          title: 'Enter the Amount',
          description:
            'Type how much money you want to send. You can choose either sender or receiver side to calculate.',
          side: 'bottom',
          align: 'end',
        },
      },
      {
        element: '#currencyIngress',
        popover: {
          title: 'Select Sending Currency',
          description:
            'Choose the currency you will use to send money from your side.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '#currencyEgress',
        popover: {
          title: 'Select Receiving Currency',
          description:
            'Select the currency that the receiver will get in their country.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '#modeOfPayment',
        popover: {
          title: 'Payment Method',
          description:
            'Choose how you want to pay such as bank transfer, cash, or other available options.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#receiver',
        popover: {
          title: 'Select Receiver',
          description:
            'Pick the person who will receive the money. You can also create or view receiver details.',
          side: 'top',
          align: 'start',
        },
      },
      {
        element: '#modeOfPayout',
        popover: {
          title: 'Receiver Payout Method',
          description:
            'Select how the receiver will get the money bank deposit, cash pickup, or any available method.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '#purpose',
        popover: {
          title: 'Purpose of Transfer',
          description:
            'Select why you are sending money required for compliance and security.',
          side: 'top',
          align: 'start',
        },
      },
    ];
    if (this.showCreateTransaction) {
      steps.push({
        element: '#sendMoney',
        popover: {
          title: 'Send Money',
          description:
            'Review all details and click here to complete your transaction safely.',
          side: 'top',
          align: 'start',
        },
      });
    }
    this.driverObj = driver({
      showProgress: true,
      animate: true,
      showButtons: ['next', 'previous', 'close'],
      onHighlighted: (element) => {
        element?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      },
      steps: steps,
    });

    this.driverObj.drive();
  }

  ngOnInit() {
    window.addEventListener('beforeunload', () => {
      if (localStorage.getItem('copyEstimateData') == 'true') {
        localStorage.removeItem('copyEstimateData');
        localStorage.removeItem('EstimateData');
      }
    });
    this.estimateForm = this.formBuilder.group({
      amount: [1.0, [Validators.required]],
      receiveAmount: [0, [Validators.required]],
      inGressCurrencyISO3: [null, [Validators.required]],
      eGressCurrencyISO3: [null, [Validators.required]],
      wantToCheckFromReceiverSide: [false],
      calculateChargeExclusive: [true],
    });
    if (this.forTransactionPage) {
      this.estimateForm.addControl(
        'modeOfPayment',
        this.formBuilder.control(null)
      );
      this.estimateForm.addControl(
        'modeOfPaymentName',
        this.formBuilder.control(null)
      );
      this.estimateForm.addControl(
        'receiverUserId',
        this.formBuilder.control(null)
      );
      this.estimateForm.addControl(
        'receiverUserName',
        this.formBuilder.control(null)
      );
      this.estimateForm.addControl(
        'relationship',
        this.formBuilder.control(null)
      );
      this.estimateForm.addControl(
        'modeOfPayout',
        this.formBuilder.control(null)
      );
      this.estimateForm.addControl(
        'modeOfPayoutName',
        this.formBuilder.control(null)
      );

      this.estimateForm.addControl(
        'inGressCountryISO3',
        this.formBuilder.control(null)
      );
      this.estimateForm.addControl(
        'eGressCountryISO3',
        this.formBuilder.control(null)
      );
      /* field for payment details */
      this.estimateForm.addControl(
        'paymentDetailsValueId',
        this.formBuilder.control(null)
      );
      this.loginType = localStorage.getItem(
        this.constants.isLoginType
      ) as string;
      if (this.loginType == 'PARTNER' || this.loginType == 'SUB_USER') {
        this.estimateForm.addControl(
          'purposeId',
          this.formBuilder.control(null)
        );
        this.estimateForm.addControl(
          'customerUserId',
          this.formBuilder.control(null)
        );
        this.estimateForm.addControl(
          'customerUserName',
          this.formBuilder.control(null)
        );
        this.userParams = {
          showOnlyCustomersUnderYou: false,
        };
        // this.countryListForIngress();
        // this.countryListForEgress();
      }
      if (this.loginType == 'CUSTOMER') {
        this.estimateForm.addControl(
          'purposeId',
          this.formBuilder.control(null)
        );
        // this.receiver$ = this.currentReceiverSubject.asObservable();
        // this.receiverListForSelect().subscribe();
        
        let userInfo: any = localStorage.getItem('UserInfo');
        this.customerId = JSON.parse(userInfo)['id'];
      }
      // this.getModeOfPayoutOption();
      // this.getModeOfPaymentOption();
      // this.getPurposes();
    }
    // this.currencyListForIngress().subscribe();
    // this.currencyListForEgress().subscribe();

    this.lockedChargeStrategy = true;
    this.estimateForm.valueChanges
      .pipe(
        debounceTime(1000 * 1),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
        ),
        filter((values) => {
          const isFormValid =
            values &&
            (values.amount || values.receiveAmount) &&
            values.inGressCurrencyISO3 &&
            values.eGressCurrencyISO3;

          const isCheckFromAmount =
            this.estimateForm.controls['wantToCheckFromReceiverSide'].value ===
              false && values.amount > 0;

          const isCheckFromReceiverAmount =
            this.estimateForm.controls['wantToCheckFromReceiverSide'].value ===
              true && values.receiveAmount > 0;
          return (
            isFormValid && (isCheckFromAmount || isCheckFromReceiverAmount)
          );
        }),
        tap(() => {
          this.isLoading = true;
          this.error = false;
          // this.estimateForm.disable(); // Disable form before API call
        }),
        switchMap((values) =>
          this._transactionService.getEstimate(values).pipe(
            catchError((error) => {
              this.isLoading = false;
              this.error = true;
              // this.estimateForm.enable(); // Re-enable form on error
              if (error.errorAction !== ErrorAction.HANDLED) {
                const formattedMessage =
                  '<ul class="list-unstyled mb-1">' +
                  error.message
                    .split(';')
                    .map((msg: any) => `<li>${msg.trim()}</li>`)
                    .join('') +
                  '</ul>';

                this.dialog.showToast(
                  formattedMessage,
                  MessageType.ERROR,
                  8000
                );
                if (this.showTourGuide && !this.tourStarted) {
                  this.tourStarted = true;
                  setTimeout(() => {
                    this.startTour();
                  }, 500);
                }
                if(!this.forTransactionPage && this.selectedCountry){
                  if(this.selectedCountry!=this.estimateForm.controls['eGressCurrencyISO3'].value){
                    this.estimateForm.controls['eGressCurrencyISO3'].setValue(this.selectedCountry);
                  }
                  this.selectedCountry='';
                }
              }
              return of(null); // Keep stream alive
            })
          )
        )
      )
      .subscribe((res) => {
        this.isLoading = false;
        // this.estimateForm.enable(); // Re-enable form after success or error
        if (res) {
          if (this.showTourGuide && !this.tourStarted) {
            this.tourStarted = true;
            setTimeout(() => {
              this.startTour();
            }, 500);
          }
          localStorage.setItem(
            'lockedChargeStrategy',
            this.lockedChargeStrategy ? 'TRUE' : 'FALSE'
          );
          this.estimateDetails = res;
          this.cdr.detectChanges();
          if (
            this.estimateForm.controls['wantToCheckFromReceiverSide'].value ===
            true
          ) {
            const formattedAmount = Number(this.estimateDetails.amount).toFixed(
              2
            );
            this.estimateForm.controls['amount'].setValue(formattedAmount);
          }
          if (
            this.estimateForm.controls['wantToCheckFromReceiverSide'].value ===
            false
          ) {
            const formattedReceiveAmount = Number(
              this.estimateDetails.payoutAmount
            ).toFixed(2);
            this.estimateForm.controls['receiveAmount'].setValue(
              formattedReceiveAmount
            );
          }
          if (this.forTransactionPage) {
            this.estimateForm.controls['modeOfPaymentName'].setValue(
              this.estimateDetails.inGressPaymentMethodCode
                .replace('_', ' ')
                .toLowerCase()
                .replace(/\b\w/g, (char: any) => char.toUpperCase()),
              { emitEvent: true }
            );
            this.estimateForm.controls['modeOfPayment'].setValue(
              this.estimateDetails.inGressPaymentMethodCode,
              { emitEvent: true }
            );
            this.estimateForm.controls['modeOfPayoutName'].setValue(
              this.estimateDetails.egressPaymentMethodCode
                .replace('_', ' ')
                .toLowerCase()
                .replace(/\b\w/g, (char: any) => char.toUpperCase()),
              { emitEvent: true }
            );
            this.estimateForm.controls['modeOfPayout'].setValue(
              this.estimateDetails.egressPaymentMethodCode,
              { emitEvent: true }
            );
            let receiverId = this.estimateForm.controls['receiverUserId']?.value;
            let payoutMode = this.estimateForm.get('modeOfPayout')?.value;
            let payoutDetailsValueId = this.estimateForm.get('paymentDetailsValueId')?.value;
            if (receiverId && payoutMode && !payoutDetailsValueId) {
              this.getPaymentDetails(receiverId,payoutMode,payoutDetailsValueId);
            }
            if (this.loginType == 'CUSTOMER') {
              localStorage.setItem(
                'EstimateData',
                JSON.stringify(this.estimateForm.value)
              );
            }
            if (localStorage.getItem('copyEstimateData') == 'true') {
              localStorage.removeItem('copyEstimateData');
              localStorage.removeItem('EstimateData');
            }
            this.estimateData = this.estimateForm.value;
          }else if(!this.forTransactionPage && this.selectedCountry){
            if(this.selectedCountry!=this.estimateForm.controls['eGressCurrencyISO3'].value){
              this.estimateForm.controls['eGressCurrencyISO3'].setValue(this.selectedCountry);
            }
            this.selectedCountry='';
          }
        }
      });
    if (isPlatformBrowser(this.platformId)) {
      this.estimateData = localStorage.getItem('EstimateData');
      if (this.loginType == 'CUSTOMER' && !this.estimateData) {
        this.showTourGuide = true;
      }
      let savedLockedChargeStrategy = localStorage.getItem(
        'lockedChargeStrategy'
      );
      this.estimateForm.patchValue(JSON.parse(this.estimateData));
      if (JSON.parse(this.estimateData)?.wantToCheckFromReceiverSide) {
        this.lastEditedAmout = false;
      }
      if (savedLockedChargeStrategy == 'TRUE') {
        this.lockedChargeStrategy = true;
      }
      if (this.estimateData) {
        if (this.estimateForm.controls['amount']?.value == null) {
          this.estimateForm.controls['amount'].setValue(0);
        }
        if (this.estimateForm.controls['receiveAmount']?.value == null) {
          this.estimateForm.controls['receiveAmount'].setValue(0);
        }
        if (this.forTransactionPage) {
          const customerId =
          this.loginType === 'CUSTOMER'
            ? this.customerId
            : this.estimateForm.controls['customerUserId']?.value;
          const receiverId = this.estimateForm.controls['receiverUserId']?.value;
          if (customerId) {
            this.customerList = [];
            if(this.loginType != 'CUSTOMER'){
              this.customer$ = this.currentCustomerSubject.asObservable();
              this.customerListForSelect('', null, customerId).subscribe();
              this._transactionService.getCountryByCustomerId(customerId).subscribe(
                (res) => {
                  if (res) {
                    let data = res;
                    this.countryIngressList = [];
                    this.countryIngressList.push(data);
                    this.cdr.detectChanges();
                    this.estimateForm.controls['inGressCountryISO3'].setValue(
                      res.alpha3
                    );
                    this.currencyListForIngress(res.alpha3,true).subscribe();
                  }
                },
                (error) => {
                  if (error.errorAction != ErrorAction.HANDLED) {
                    this.dialog.showToast(error.message, MessageType.ERROR);
                  }
                }
              );
            }
            const formsObj: any = {
              customerId,
              showOnlyReceiversUnderYou: false,
            };
            if (receiverId) {
              formsObj.receiverId = receiverId;
            }
            this.receiver$ = this.currentReceiverSubject.asObservable();
            this.receiverListForSelect(formsObj).subscribe();
            if (this.loginType == 'CUSTOMER') {
              this.currencyListForIngress('',true,this.estimateForm.get('inGressCurrencyISO3')?.value).subscribe();
              this.currencyListForEgress('',true,this.estimateForm.get('eGressCurrencyISO3')?.value).subscribe();

            }
          } else if (!receiverId) {
            this.receiver$ = this.currentReceiverSubject.asObservable();
            this.receiverListForSelect().subscribe();
          }
          if (receiverId) {
            this.getModeOfPayoutOption(receiverId);
            let payoutMode = this.estimateForm.get('modeOfPayout')?.value;
            let payoutDetailsValueId = this.estimateForm.get('paymentDetailsValueId')?.value;
            if (payoutMode) {
              this.getPaymentDetails(receiverId,payoutMode,payoutDetailsValueId);
            }
            if (this.loginType == 'PARTNER' || this.loginType == 'SUB_USER') {
              this._transactionService.getCountryByCustomerId(receiverId).subscribe(
                (res) => {
                  if (res) {
                    let data = res;
                    this.countryEgressList = [];
                    this.countryEgressList.push(data);
                    this.cdr.detectChanges();
                    this.estimateForm.controls['eGressCountryISO3'].setValue(
                      res.alpha3
                    );
                    this.currencyListForEgress(res.alpha3,true).subscribe();
                  }
                },
                (error) => {
                  if (error.errorAction != ErrorAction.HANDLED) {
                    this.dialog.showToast(error.message, MessageType.ERROR);
                  }
                }
              );
            } if (this.loginType == 'CUSTOMER') {
              this.currencyListForIngress('',true,this.estimateForm.get('inGressCurrencyISO3')?.value).subscribe();
              this.currencyListForEgress('',true,this.estimateForm.get('eGressCurrencyISO3')?.value).subscribe();
            }
          }
          this.getPurposes();
        }
      }else{
      if (this.forTransactionPage) {
        if (this.loginType == 'PARTNER' || this.loginType == 'SUB_USER') {
          this.countryListForIngress();
          this.countryListForEgress();
        }
        if (this.loginType == 'CUSTOMER') {
          this.receiver$ = this.currentReceiverSubject.asObservable();
          this.receiverListForSelect().subscribe();
        }
        this.getModeOfPayoutOption();
        this.getModeOfPaymentOption();
        this.getPurposes();
      }
      this.currencyListForIngress().subscribe();
      this.currencyListForEgress().subscribe();
      }
    }
  }

  get f() {
    return this.estimateForm.controls;
  }

  onAmountInput(event: Event) {
    this.estimateForm.controls['wantToCheckFromReceiverSide'].setValue(false);
    const input = event.target as HTMLInputElement;
    const originalValue = input.value;
    const cursor = input.selectionStart || 0;
    if (!this.lastEditedAmout) {
      this.lockedChargeStrategy = false;
    }

    if (!this.lockedChargeStrategy) {
      this.estimateForm.controls['calculateChargeExclusive'].setValue(true);
      this.isToggleDisabled = false;
    }

    this.lastEditedAmout = true;

    if (originalValue === '' || originalValue === '.') return;

    let cleaned = originalValue.replace(/[^\d.\-]/g, '');
    cleaned = cleaned.replace(/(\..*?)\./g, '$1'); // remove multiple dots
    cleaned = cleaned.replace(/(?!^)-/g, ''); // only first minus allowed

    const match = cleaned.match(/^(-?)(\d*)(\.?\d*)$/);
    if (!match) return;

    let [, sign, integer, decimals] = match;

    if (integer.length > 1 && integer.startsWith('0')) {
      integer = integer.replace(/^0+/, '') || '0';
    }

    const formatted = sign + integer + decimals;

    if (formatted !== originalValue) {
      this.estimateForm
        .get('amount')
        ?.setValue(formatted, { emitEvent: false });

      // reset caret
      const diff = originalValue.length - formatted.length;
      const newPos = cursor - diff;
      setTimeout(() => input.setSelectionRange(newPos, newPos), 0);
    }
  }

  onReceiverAmountInput(event: Event) {
    this.estimateForm.controls['wantToCheckFromReceiverSide'].setValue(true);
    const input = event.target as HTMLInputElement;
    const originalValue = input.value;
    const cursor = input.selectionStart || 0;
    if (this.lastEditedAmout) {
      this.lockedChargeStrategy = false;
    }
    if (!this.lockedChargeStrategy) {
      this.estimateForm.controls['calculateChargeExclusive'].setValue(true);
      this.isToggleDisabled = true;
    }

    this.lastEditedAmout = false;

    if (originalValue === '' || originalValue === '.') return;

    let cleaned = originalValue.replace(/[^\d.\-]/g, '');
    cleaned = cleaned.replace(/(\..*?)\./g, '$1'); // remove multiple dots
    cleaned = cleaned.replace(/(?!^)-/g, ''); // only first minus allowed

    const match = cleaned.match(/^(-?)(\d*)(\.?\d*)$/);
    if (!match) return;

    let [, sign, integer, decimals] = match;

    if (integer.length > 1 && integer.startsWith('0')) {
      integer = integer.replace(/^0+/, '') || '0';
    }

    const formatted = sign + integer + decimals;

    if (formatted !== originalValue) {
      this.estimateForm
        .get('receiveAmount')
        ?.setValue(formatted, { emitEvent: false });

      // reset caret
      const diff = originalValue.length - formatted.length;
      const newPos = cursor - diff;
      setTimeout(() => input.setSelectionRange(newPos, newPos), 0);
    }
  }

  ngAfterViewInit() {
    this.checkRowWidth();
    this.cdr.detectChanges();

    this.messageEmitEventListener = (event: any) => {
      if (event.origin != this.baseUrl) return;

      let msgData = event.data;
      if ('type' in msgData && msgData['type'] == 'customer') {
        // this.estimateForm.patchValue({
        //   customerUserName: msgData['name'],
        // });
      }

      if ('type' in msgData && msgData['type'] == 'receiver') {
        this.receiver$ = this.currentReceiverSubject.asObservable();
        this.receiverListForSelect({
          customerId: this.estimateForm.controls['customerUserId'].value,
          showOnlyReceiversUnderYou: false,
        }).subscribe();
        // this.estimateForm.patchValue({
        //   receiverUserName: msgData['name'],
        // });
      }
    };

    window.addEventListener('message', this.messageEmitEventListener, false);
  }

  @HostListener('window:resize', [])
  checkRowWidth() {
    if (this.rowContainer) {
      const rowWidth = this.rowContainer.nativeElement.offsetWidth;
      const newIsWideScreen = rowWidth > 550;
      if (this.isWideScreen !== newIsWideScreen) {
        this.isWideScreen = newIsWideScreen;
        this.cdr.detectChanges();
      }
    }
  }

  setState(value: true | false) {
    this.lockedChargeStrategy = true;
    this.estimateForm.get('calculateChargeExclusive')?.setValue(value);
  }

  countryListForIngress() {
    this._transactionService
      .getIngressCountriesAvailableTransaction(this.userParams)
      .subscribe((data) => {
        this.countryIngressList = [];
        this.countryIngressList = data;
      });
  }

  countryListForEgress() {
    this._transactionService
      .getEgressCountriesAvailableTransaction(this.userParams)
      .subscribe((data) => {
        this.countryEgressList = [];
        this.countryEgressList = data;
      });
  }

  currencyListForIngress(countryCode:any='',preFillWithPreviosCode:boolean=false,currencyCode:any=''): Observable<any> {
    let userParams={};
    if(countryCode){
       userParams = {
      ...this.userParams,
      ingressCountryISO3:countryCode
      };
    }else{
      userParams = {
      ...this.userParams,
      }
    }
    return this._transactionService
      .getIngressCurrenciesAvailableTransaction(userParams)
      .pipe(
        map((res: any) => {
          let data = res.data;
          this.currencyIngressList = [];
          this.currencyIngressList.push(...data);
          if (!preFillWithPreviosCode) {
            this.estimateForm.controls['inGressCurrencyISO3'].setValue(
              this.currencyIngressList[0]?.code
            );
          }if(currencyCode){
            const selectedCurrency = this.currencyIngressList.find(
              (item: any) => item.code === currencyCode
            );
            this.estimateForm.controls['inGressCurrencyISO3'].setValue(
              selectedCurrency?.code
            );
          }
          return res;
        }),
        catchError((err) => {
          return of('error', err);
        })
      );
  }

  currencyListForEgress(countryCode:any='',preFillWithPreviosCode:boolean=false,currencyCode:any=''): Observable<any> {
    let userParams={};
    if(countryCode){
       userParams = {
      ...this.userParams,
      egressCountryISO3:countryCode
      };
    }else{
      userParams = {
      ...this.userParams,
      }
    }
    return this._transactionService
      .getEgressCurrenciesAvailableTransaction(userParams)
      .pipe(
        map((res: any) => {
          let data = res.data;
          this.currencyEgressList = [];
          this.currencyEgressList.push(...data);
          if (!preFillWithPreviosCode) {
            this.estimateForm.controls['eGressCurrencyISO3'].setValue(
              this.currencyEgressList[0]?.code
            );
          }
          if(currencyCode){
            const selectedCurrency = this.currencyEgressList.find(
              (item: any) => item.code === currencyCode
            );
            this.estimateForm.controls['eGressCurrencyISO3'].setValue(
              selectedCurrency?.code
            );
          }
          return res;
        }),
        catchError((err) => {
          return of('error', err);
        })
      );
  }

  getModeOfPayoutOption(receiverId: any = '') {
    let userParams = { ...this.userParams };
    if (receiverId) {
      userParams = { ...userParams, egressCustomerId: receiverId };
    }
    this._transactionService
      .getPayoutOptionsForTransaction(userParams)
      .subscribe((res) => {
        let data = res;

        data.forEach((val: any) => {
          if (
            val.miscKwOne == 'Not_enabled_for_partner' ||
            val.miscKwOne == 'Not_added_by_customer'
          ) {
            val.disabled = true;
          }
        });
        this.modeOfPayoutList = [];
        this.modeOfPayoutList.push(...data);
      });
  }

  getModeOfPaymentOption() {
    this._transactionService
      .getPaymentOptionsForTransaction(this.userParams)
      .subscribe((res) => {
        let data = res;
        this.modeOfPaymentList = [];
        this.modeOfPaymentList.push(...data);
      });
  }

  customerListForSelect(
    offsetToken: string = '',
    searchTerm: any = null,
    customerUserId: any = null
  ): Observable<any> {
    let userParams = {
      ...this.userParams,
      considerOnlyCustomersWithTransaction: JSON.parse(
        localStorage.getItem('usedMyPaymentMethod') || 'false'
      ),
      considerOnlyCustomersCreatedByYou: JSON.parse(
        localStorage.getItem('createdByMe') || 'false'
      ),
    };

    return this._transactionService
      .getCustomer(userParams, searchTerm, customerUserId, null)
      .pipe(
        map((res: any) => {
          let data = res;
          this.dataLengthForCustomer = data.length;
          this.customerList = [];
          this.customerList.push(...data);
          this.currentCustomerSubject.next(this.customerList);
          this.cdr.detectChanges();
          return res;
        }),
        catchError((err) => {
          return of('error', err);
        })
      );
  }

  getCustomerValue(e: any) {
    this.estimateForm.controls['customerUserId'].setValue(null);
    this.estimateForm.controls['customerUserName'].setValue(null);
    this.estimateForm.controls['receiverUserId'].setValue(null);
    this.estimateForm.controls['receiverUserName'].setValue(null);
    this.estimateForm.controls['relationship'].setValue(null);
    this.estimateForm.controls['modeOfPayout'].setValue(null);
    this.estimateForm.controls['modeOfPayoutName'].setValue(null);
    this.estimateForm.controls['inGressCountryISO3'].setValue(null);
    this.estimateForm.controls['eGressCountryISO3'].setValue(null);
    this.estimateForm.controls['paymentDetailsValueId'].setValue(null);
    this.receiverList = [];
    this.offsetTokenValueForReceiver = '';
    this.dataLengthForReceiver = null;
    this.countryIngressList = [];
    this.countryEgressList = [];
    this.modeOfPayoutList = [];
    this.paymentDetailsData = [];
    if (e) {
      this.estimateForm.controls['customerUserId'].setValue(e.id);
      this.estimateForm.controls['customerUserName'].setValue(e.name);
      this._transactionService.getCountryByCustomerId(e.id).subscribe(
        (res) => {
          if (res) {
            let data = res;
            this.countryIngressList = [];
            this.countryIngressList.push(data);
            this.cdr.detectChanges();
            this.estimateForm.controls['inGressCountryISO3'].setValue(
              res.alpha3
            );
            this.currencyListForIngress(res.alpha3).subscribe();
          }
        },
        (error) => {
          if (error.errorAction != ErrorAction.HANDLED) {
            this.dialog.showToast(error.message, MessageType.ERROR);
          }
        }
      );
      this.currentReceiverSubject.next(this.receiverList);
      this.ngSelects.detectChanges();
      this.cdr.detectChanges();
      this.receiver$ = this.currentReceiverSubject.asObservable();
      this.receiverListForSelect({
        customerId: e.id,
        showOnlyReceiversUnderYou: false,
      }).subscribe();
      this.countryListForEgress();
      this.getModeOfPayoutOption();
    } else {
      this.currentReceiverSubject.next(this.receiverList);
      this.ngSelects.detectChanges();
      this.cdr.detectChanges();
      this.countryListForEgress();
      this.countryListForIngress();
      this.getModeOfPayoutOption();
      this.currencyListForIngress().subscribe();
    }
  }

  @ViewChild(NgSelectComponent) ngSelects!: NgSelectComponent;
  receiverListForSelect(
    formOp: any = '',
    offsetToken: string = '',
    searchTerm: any = null
  ): Observable<any> {
    return this._transactionService
      .getAllReceiver(formOp, offsetToken, searchTerm)
      .pipe(
        map((res: any) => {
          let data = res.data;

          this.dataLengthForReceiver = data.length;
          this.offsetTokenValueForReceiver = res.offsetToken;

          data = data.map((r: any) => ({
            ...r,
            loading: true,
            parentName: null,
          }));

          this.receiverList.push(...data);

          this.uniqueIdsForReceiver = [];
          this.receiverList = this.receiverList.filter((item: any) => {
            let found = this.uniqueIdsForReceiver.includes(item.id);
            if (!found) this.uniqueIdsForReceiver.push(item.id);
            return !found;
          });
          from(this.receiverList)
            .pipe(
              mergeMap((receiver: any) =>
                this._transactionService.getReceiverById(receiver.id).pipe(
                  map((details: any) => {
                    const index = this.receiverList.findIndex(
                      (r) => r.id === receiver.id
                    );
                    if (index > -1) {
                      this.receiverList[index] = {
                        ...receiver,
                        paymentDetails:
                          details.receiverData.paymentDetailsFieldValues,
                        countryAlpha3:details.receiverData.country.alpha3,
                        loading: false,
                      };
                      this.currentReceiverSubject.next([...this.receiverList]);
                      // this.currencyListForIngress(details.ownerCustomer.country.alpha3).subscribe();
                      // this.currencyListForEgress(details.receiverData.country.alpha3).subscribe();
                      this.ngSelects.detectChanges();
                      this.cdr.detectChanges();
                    }
                  }),
                  catchError(() => {
                    const index = this.receiverList.findIndex(
                      (r) => r.id === receiver.id
                    );
                    if (index > -1) {
                      this.receiverList[index].loading = false;
                      this.currentReceiverSubject.next([...this.receiverList]);
                    }
                    return of(null);
                  })
                )
              )
            )
            .subscribe();

          this.currentReceiverSubject.next(this.receiverList);
          return res;
        })
      );
  }

  receiverScroll() {
    if (this.dataLengthForReceiver == API_Limit) {
      this.receiverListForSelect(
        {
          customerId: this.estimateForm.controls['customerUserId'].value,
          showOnlyReceiversUnderYou: false,
        },
        this.offsetTokenValueForReceiver,
        this.searchTermForReceiver
      ).subscribe();
    }
  }

  getReceiverValue(e: any) {
    this.countryEgressList = [];
    this.estimateForm.controls['receiverUserId'].setValue(null);
    this.estimateForm.controls['receiverUserName'].setValue(null);
    this.estimateForm.controls['relationship'].setValue(null);
    this.estimateForm.controls['modeOfPayout'].setValue(null);
    this.estimateForm.controls['modeOfPayoutName'].setValue(null);
    this.estimateForm.controls['paymentDetailsValueId'].setValue(null);
    this.estimateForm.controls['eGressCountryISO3'].setValue(null);
    this.paymentDetailsData = [];
    if (e) {
      this.estimateForm.controls['receiverUserId'].setValue(e.id);
      this.estimateForm.controls['receiverUserName'].setValue(e.name);
      this.estimateForm.controls['relationship'].setValue(e.relationship);
      this.getModeOfPayoutOption(e.id);
      if (this.loginType == 'PARTNER' || this.loginType == 'SUB_USER') {
        this._transactionService.getCountryByCustomerId(e.id).subscribe(
          (res) => {
            if (res) {
              let data = res;
              this.countryEgressList = [];
              this.countryEgressList.push(data);
              this.cdr.detectChanges();
              this.estimateForm.controls['eGressCountryISO3'].setValue(
                res.alpha3
              );
              this.currencyListForEgress(res.alpha3).subscribe();
            }
          },
          (error) => {
            if (error.errorAction != ErrorAction.HANDLED) {
              this.dialog.showToast(error.message, MessageType.ERROR);
            }
          }
        );
      } if (this.loginType == 'CUSTOMER') {
        this.currencyListForEgress(e.countryAlpha3).subscribe();
      }
    } else {
      this.countryListForEgress();
      this.getModeOfPayoutOption();
      this.currencyListForEgress().subscribe();
    }
  }

  openModal(template: TemplateRef<any>, label: any) {
    this.modalRef = this.modalService.show(template, this.config);
    this.showField = label;
  }

  getPaymentValue(e: any) {
    this.modalRef?.hide();
    this.cdr.detectChanges();
    if (this.showField == 'payment' && e) {
      this.estimateForm.controls['modeOfPayment'].setValue(e.code);
      this.estimateForm.controls['modeOfPaymentName'].setValue(e.name);
    }
    if (this.showField == 'payment' && !e) {
      this.estimateForm.controls['modeOfPayment'].setValue(null);
      this.estimateForm.controls['modeOfPaymentName'].setValue(null);
    }
    if (this.showField == 'payout' && e) {
      this.estimateForm.controls['modeOfPayout'].setValue(e.code);
      this.estimateForm.controls['modeOfPayoutName'].setValue(e.name);
      this.paymentDetailsData = [];
      this.estimateForm.get('paymentDetailsValueId')?.setValue(null);
      const receiverId = this.estimateForm.controls['receiverUserId']?.value;
      if (receiverId) {
        this.getPaymentDetails(receiverId,e.code,'');
      }
    }
    if (this.showField == 'payout' && !e) {
      this.estimateForm.controls['modeOfPayout'].setValue(null);
      this.estimateForm.controls['modeOfPayoutName'].setValue(null);
      this.paymentDetailsData=[];
      this.estimateForm.get('paymentDetailsValueId')?.setValue(null);
    }
    if (this.showField == 'receiver' && e) {
      this.estimateForm.controls['receiverUserName'].setValue(e.name);
      this.estimateForm.controls['receiverUserId'].setValue(e.id);
      this.estimateForm.controls['relationship'].setValue(e.relationship);
      this.getReceiverValue(e);
    }
    if (this.showField == 'receiver' && !e) {
      this.estimateForm.controls['receiverUserName'].setValue(null);
      this.estimateForm.controls['receiverUserId'].setValue(null);
      this.estimateForm.controls['relationship'].setValue(null);
      this.getReceiverValue(e);
    }
  }

  getPayoutValue(e: any) {
    this.paymentDetailsData=[];
    this.estimateForm.get('paymentDetailsValueId')?.setValue(null);
    if (e) {
      this.estimateForm.controls['modeOfPayout'].setValue(e.code);
      this.estimateForm.controls['modeOfPayoutName'].setValue(e.name);
      const receiverId = this.estimateForm.controls['receiverUserId']?.value;
      if (receiverId) {
        this.getPaymentDetails(receiverId,e.code,'');
      }
    } else {
      this.estimateForm.controls['modeOfPayout'].setValue(null);
      this.estimateForm.controls['modeOfPayoutName'].setValue(null);
    }
  }

  getPaymentDetails(receiverUserId:any,payoutMode:any,payoutDetailsValueId:any=''){
    this._transactionService
    .getPayoutSchemaValueOptionsForTransaction(
      receiverUserId,
      payoutMode.toUpperCase(),
    )
    .subscribe({
      next: (res: any) => {
        if (res) {
          // create formatted label
          let formattedData = res.map((payment: any) => {
            if (
              payment.fieldSchemaValues.length > 0 &&
              payment.fieldSchemaValues[0].fieldSchema.type ==
                'SELECT'
            ) {
              payment.fieldSchemaValues[0].value = '';
              this._countryService
                .getFieldSchemaValueDetailsForSelectOption(
                  payment.fieldSchemaValues[0].id,
                  true
                )
                .subscribe((val) => {
                  if (val) {
                    payment.fieldSchemaValues[0].value =
                      val.description;
                    payment[
                      'detailLabel'
                    ] = `${payment.label} Country Name: ${val.description}
                    Payment Mode: ${payment.paymentDetailsSchema.modeOfPaymentOrPayout}`;
                  }
                });
            } else {
              payment[
                'detailLabel'
              ] = `${payment.label} Country Name: ${payment.fieldSchemaValues[0].value}
              Payment Mode: ${payment.paymentDetailsSchema.modeOfPaymentOrPayout}`;
            }
            return payment;
          });
          this.paymentDetailsData = formattedData;
          // console.log(formattedData,this.paymentDetailsData)
          if (this.paymentDetailsData.length >= 1) {
            this.showWarningMessage = false;
            // let paymentDetailsId = this.paymentDetailsData[0].id;
            // let selectedPaymentDetails = this.estimateForm.get(
            //   'paymentDetailsValueId'
            // )?.value;

            const selectedPayment = this.paymentDetailsData.find(
              (item: any) => item.id === payoutDetailsValueId
            );

            this.estimateForm.patchValue(
              {
                paymentDetailsValueId: selectedPayment
                  ? selectedPayment.id
                  : this.paymentDetailsData[0].id,
              },
              { emitEvent: false }
            );

            // console.log(this.estimateForm,this.paymentDetailsData,selectedPayment)
            // this.estimateForm.patchValue(
            //   {
            //     paymentDetailsValueId: paymentDetailsId,
            //   },
            //   { emitEvent: false }
            // );
          }
          if (this.paymentDetailsData.length == 0) {
            this.showWarningMessage = true;
          }
          this.cdr.detectChanges()
        }
      },
    });
  }
  
  getFormattedChargeDesc(raw: any): SafeHtml {
    return raw
      .split('\n')
      .filter((line: any) => line.includes(':'))
      .map((line: any) => {
        const [key, value] = line.split(':');
        return {
          key: key.trim(),
          value: value.trim(),
        };
      });
  }

  async onCreateTransaction() {
    this.showCreateTransaction = false;
    const deviceInfo = await this._transactionService.getFingerprint();
    const ipAddress = await this._transactionService.getPublicIP();

    const fingerprintData = `${deviceInfo.userAgent}|${deviceInfo.screenResolution}|${deviceInfo.platform}|${deviceInfo.language}|timezone=${deviceInfo.timezone}|fingerprint=${deviceInfo.visitorId}|ip=${ipAddress}`;

    const payload = {
      transactionEncryptedData: this.estimateDetails.hashString,
      customerId: this.estimateForm.value.customerUserId
        ? this.estimateForm.value.customerUserId
        : '',
      receiverId: this.estimateForm.value.receiverUserId
        ? this.estimateForm.value.receiverUserId
        : '',
      purposeId: this.estimateForm.value.purposeId
        ? this.estimateForm.value.purposeId
        : '',
      deviceFingerPrint: fingerprintData,
      paymentDetailsValueId: this.estimateForm.value.paymentDetailsValueId
        ? this.estimateForm.value.paymentDetailsValueId
        : '',
    };
    this._transactionService.createTransaction(payload).subscribe(
      (res) => {
        this.dialog.showToast(res.message, MessageType.SUCCESS);
        this.router.navigate([
          '/transaction/transaction-details/' + res.miscData,
        ]);
      },
      (error) => {
        this.showCreateTransaction = true;
        if (error.errorAction != ErrorAction.HANDLED) {
          this.dialog.showToast(error.message, MessageType.ERROR);
        }
      }
    );
  }

  getPurposes() {
    this._transactionService.getPurposes().subscribe((res) => {
      this.purposeList = [];
      this.purposeList.push(...res.data);
    });
  }

  createInNewTab(type: string) {
    let url = '';
    if (type == 'customer') {
      this.estimateForm.controls['customerUserId'].setValue(null);
      this.estimateForm.controls['customerUserName'].setValue(null);
      this.estimateForm.controls['receiverUserId'].setValue(null);
      this.estimateForm.controls['receiverUserName'].setValue(null);
      this.estimateForm.controls['relationship'].setValue(null);
      this.estimateForm.controls['modeOfPayout'].setValue(null);
      this.estimateForm.controls['modeOfPayoutName'].setValue(null);
      this.estimateForm.controls['inGressCountryISO3'].setValue(null);
      this.estimateForm.controls['eGressCountryISO3'].setValue(null);
      this.estimateForm.controls['paymentDetailsValueId'].setValue(null);
      this.receiverList = [];
      this.offsetTokenValueForReceiver = '';
      this.dataLengthForReceiver = null;
      this.countryIngressList = [];
      this.countryEgressList = [];
      this.modeOfPayoutList = [];
      this.paymentDetailsData = [];
      this.currentReceiverSubject.next(this.receiverList);
      this.countryListForEgress();
      this.countryListForIngress();
      this.getModeOfPayoutOption();

      url = this.router.serializeUrl(
        this.router.createUrlTree(['create-customer'], {
          queryParams: { 'update-transaction': true },
        })
      );
    } else {
      let selectedCustomer: any = '';
      if (this.estimateForm.get('customerUserId')?.value) {
        selectedCustomer = this.estimateForm.get('customerUserId')?.value;
      }

      // changes for customer user
      if (this.loginType == 'CUSTOMER') {
        selectedCustomer = this.customerId;
      }

      if (!selectedCustomer) {
        this.dialog.showToast(
          'No customer has been selected, Please select a customer first',
          MessageType.ERROR
        );
        return;
      }
      this.countryEgressList = [];
      this.estimateForm.controls['receiverUserId'].setValue(null);
      this.estimateForm.controls['receiverUserName'].setValue(null);
      this.estimateForm.controls['relationship'].setValue(null);
      this.estimateForm.controls['modeOfPayout'].setValue(null);
      this.estimateForm.controls['modeOfPayoutName'].setValue(null);
      this.estimateForm.controls['paymentDetailsValueId'].setValue(null);
      this.estimateForm.controls['eGressCountryISO3'].setValue(null);
      this.paymentDetailsData = [];
      this.receiverList = [];
      this.currentReceiverSubject.next(this.receiverList);
      const targetUrl =
        `${environment.base_url}` + '/receiver/getReceivers?limit=20';

      const index = this._transactionService.receiverCache.findIndex(
        (item) => item.url === targetUrl
      );

      if (index !== -1) {
        this._transactionService.receiverCache.splice(index, 1);
      }
      this.countryListForEgress();
      this.getModeOfPayoutOption();
      url = this.router.serializeUrl(
        this.router.createUrlTree(['receiver/add-receiver'], {
          queryParams: {
            'update-transaction': true,
            'customer-id': selectedCustomer,
          },
        })
      );
    }

    let popupWindow = window.open(
      url,
      this.constants.openLinksInNewTab ? '_blank' : '_self'
    );
    if (popupWindow) {
      this.checkPopupClosed(popupWindow).subscribe(() => {
        if (type != 'customer') {
          this.receiver$ = this.currentReceiverSubject.asObservable();
          this.receiverListForSelect().subscribe();
        }
      });
    }
  }

  private popupWindow: Window | null = null;
  gotoReceiverDetails(type: any) {
    let url = '';
    let selectedReceiver: any = '';
    if (this.estimateForm.get('receiverUserId')?.value) {
      selectedReceiver = this.estimateForm.get('receiverUserId')?.value;
    }

    if (!selectedReceiver) {
      this.dialog.showToast(
        'No receiver has been selected, Please select a receiver first',
        MessageType.ERROR
      );
      return;
    }

    if (type == 'details') {
      url = this.router.serializeUrl(
        this.router.createUrlTree(['receiver-details/' + selectedReceiver])
      );
    } else {
      url = this.router.serializeUrl(
        this.router.createUrlTree(
          ['receiver/update-receiver/' + selectedReceiver],
          {
            queryParams: {
              'update-transaction': true,
            },
          }
        )
      );
    }

    this.popupWindow = window.open(
      url,
      this.constants.openLinksInNewTab ? '_blank' : '_self'
    );
    if (this.popupWindow) {
      this.checkPopupClosed(this.popupWindow).subscribe(() => {
        let customerUserId = this.estimateForm.get('receiverUserId')?.value;
        let payoutMode = this.estimateForm.get('modeOfPayout')?.value;
        if (customerUserId && payoutMode) {
          this._transactionService
            .getPayoutSchemaValueOptionsForTransaction(
              customerUserId,
              payoutMode.toUpperCase()
            )
            .subscribe({
              next: (res: any) => {
                if (res) {
                  // create formatted label
                  let formattedData = res.map((payment: any) => {
                    if (
                      payment.fieldSchemaValues.length > 0 &&
                      payment.fieldSchemaValues[0].fieldSchema.type == 'SELECT'
                    ) {
                      payment.fieldSchemaValues[0].value = '';
                      this._countryService
                        .getFieldSchemaValueDetailsForSelectOption(
                          payment.fieldSchemaValues[0].id,
                          true
                        )
                        .subscribe((val) => {
                          if (val) {
                            payment.fieldSchemaValues[0].value =
                              val.description;
                            payment[
                              'detailLabel'
                            ] = `${payment.label} Country Name: ${val.description}
                               Payment Mode: ${payment.paymentDetailsSchema.modeOfPaymentOrPayout}`;
                          }
                        });
                    } else {
                      payment[
                        'detailLabel'
                      ] = `${payment.label} Country Name: ${payment.fieldSchemaValues[0].value}
                         Payment Mode: ${payment.paymentDetailsSchema.modeOfPaymentOrPayout}`;
                    }
                    return payment;
                  });

                  this.paymentDetailsData = formattedData;
                  if (this.paymentDetailsData.length >= 1) {
                    this.showWarningMessage = false;
                    let paymentDetailsId = this.paymentDetailsData[0].id;
                    let selectedPaymentDetails = this.estimateForm.get(
                      'paymentDetailsValueId'
                    )?.value;

                    // set first value to true only when form field is not set
                    if (!selectedPaymentDetails) {
                      this.estimateForm.patchValue(
                        {
                          paymentDetailsValueId: paymentDetailsId,
                        },
                        { emitEvent: false }
                      );
                    }
                  }
                  if (this.paymentDetailsData.length == 0) {
                    this.showWarningMessage = true;
                  }
                }
              },
            });
        }
      });
    }
  }

  checkPopupClosed(winRef: Window): Observable<void> {
    return new Observable((observer) => {
      const interval = setInterval(() => {
        if (winRef.closed) {
          observer.next();
          observer.complete();
          clearInterval(interval);
        }
      }, 500);
    });
  }

  gotoDocumentPage() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/document/get-all'], {
        queryParams: {
          userId: this.estimateForm.controls['customerUserId'].value,
          userType: 'CUSTOMER',
        },
      })
    );

    window.open(url, this.constants.openLinksInNewTab ? '_blank' : '_self');
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.messageEmitEventListener, false);
    if (this.modalService.getModalsCount() > 0) {
      this.modalService.hide();
    }
    this._transactionService.paymentOptionsListSubject.next([]);
    this._transactionService.payoutOptionsListSubject.next([]);
    this._transactionService.ingressCountriesListSubject.next([]);
    this._transactionService.egressCountriesListSubject.next([]);
    this._transactionService.customerListSubject.next([]);
    this._transactionService.receiverListSubject.next([]);
    this._transactionService.receiverListByIdSubject.next([]);
    this._transactionService.fieldSchemaValueListSubject.next([]);
    this._countryService.fieldSchemaValueDetailsForSelectListSubject.next([]);

    this._transactionService.paymentOptionsCache = [];
    this._transactionService.payoutOptionsCache = [];
    this._transactionService.ingressCountriesCache = [];
    this._transactionService.egressCountriesCache = [];
    this._transactionService.customerCache = [];
    this._transactionService.receiverCache = [];
    this._transactionService.receiverByIdCache = [];
    this._transactionService.fieldSchemaValueCache = [];
    this._countryService.fieldSchemaValueDetailsForSelectCache = [];
    this.showTourGuide = false;
    this.driverObj?.destroy();
    if (localStorage.getItem('copyEstimateData') == 'true') {
      localStorage.removeItem('copyEstimateData');
      localStorage.removeItem('EstimateData');
    }
  }
}
